export const EeeFaculty = [
  {
    "designation": "Professor",
    "Name": "Prof. M. Damodar Reddy",
    "Phone": "(+91)-9885428847",
    "Email": "	mdreddy999@rediffmail.com",
    "Details": "https://svuniversity.irins.org/profile/427438"
  },

  {
    "designation": "Professor",
    "Name": "Prof. A. Lakshmi Devi",
    "Phone": "	(+91)-9441080884",
    "Email": "	energylak123@yahoo.com",
    "Details": "https://svuniversity.irins.org/profile/618643"
  },
  {
    "designation": "Professor",
    "Name": "Dr. Ch. Chengaiah",
    "Phone": "	(+91)-9440403023",
    "Email": "chinthapudisvu@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/245379"
  },

  {
    "designation": "Professor",
    "Name": "Dr. T. Gowri Manoahar",
    "Phone": "(+91)-9440474441",
    "Email": "tgmanohar1973@rediffmail.com",
    "Details": "https://svuniversity.irins.org/profile/427430"
  },
  {
    "designation": "Associate Professor",
    "Name": "Dr. V. Usha Reddy",
    "Phone": "(+91)-9441116445",
    "Email": "vyza_ushareddy@yahoo.co.in",
    "Details": "https://svuniversity.irins.org/profile/462957"
  },
  {
    "designation": "Associate Professor",
    "Name": "Dr. J.N. ChandraSekhar",
    "Phone": "(+91)-9177177782",
    "Email": "	chandu.jinka@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/517442"
  }, {
    "designation": "Academic Consultant",
    "Name": "Dr.Raja Sekhar Reddy Bayyapureddy",
    "Phone": "(+91)-9966665151",
    "Email": "rajabayyapureddy@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591229"
  },

  {
    "designation": "Academic Consultant",
    "Name": "Dr.Annam Sreenivasulu",
    "Phone": "(+91)-8019393948",
    "Email": "sreenivasulu136@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591251"
  }, {
    "designation": "Academic Consultant",
    "Name": "Dr.Chella Hari Prasad",
    "Phone": "(+91)-9849035467",
    "Email": "hariprasadchallaa@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591254"
  }, {
    "designation": "Academic Consultant",
    "Name": "Chaitanya Ayya",
    "Phone": "(+91)-8374241571",
    "Email": "chaithu.maruthi@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591250"
  }, {
    "designation": "Academic Consultant",
    "Name": "Ram Prasad Kannemadugu",
    "Phone": "(+91)-9966876248",
    "Email": "ramprasad2102@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591233"
  },
  {
    "designation": "Academic Consultant",
    "Name": "M. Vijayakumar Naik",
    "Phone": "(+91)-7989725945",
    "Email": "vijaysai262@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591825"
  },


  {
    "designation": "Academic Consultant",
    "Name": "Gayathri Pedda",
    "Phone": "(+91)-8686498757",
    "Email": "gayathripedda@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591276"
  },
  {
    "designation": "Academic Consultant",
    "Name": "Mr.M.Gopi SivaPrasad",
    "Phone": "(+91)-7893247518",
    "Email": "yadav.eps@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591305"
  },

]